import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { CircularProgress, Stack, Typography } from '@rossum/ui/material';
import { useSignInWithAuthCodeFromUrl } from '../../../business/auth/useSignInWithAuthCodeFromUrl';
import { handOffSsoPopupToken } from '../ssoPopupHandoff';

export const SSOCallback = () => {
  const closeCallback = useCallback(() => window.close(), []);

  const intl = useIntl();
  useSignInWithAuthCodeFromUrl({
    onAuthFinish: closeCallback,
    onToken: handOffSsoPopupToken,
  });

  return (
    <Stack alignItems="center" justifyContent="center" sx={{ height: '100vh' }}>
      <CircularProgress />
      <Typography sx={{ mt: 2 }}>
        {intl.formatMessage({
          id: 'containers.login.sso.callback.completing',
        })}
      </Typography>
    </Stack>
  );
};
